import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { IhmExpansionButtonComponent } from './ihm-expansion-button.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatRippleModule, MatIconModule],
  declarations: [IhmExpansionButtonComponent],
  exports: [IhmExpansionButtonComponent]
})
export class IhmExpansionButtonModule {}
